<template>
  <div>
    <Media
      v-for="(media, index) in materials"
      :key="media.cover"
      @on-delete="handleDelete(index)"
      :index="index"
      :cover="media.cover"
      :videoUrl="media.videoUrl"
      :urls="urls"
      :mediaType="media.mediaType"
    >
      <el-input
        class="mt15 mb15"
        type="textarea"
        v-model="media.content"
        autosize
      ></el-input>
    </Media>
  </div>
</template>

<script>
import Media from "@/components/Media";
export default {
  inject: ["editControl"],
  components: { Media },
  computed: {
    urls() {
      return this.materials.map((item) => item.cover);
    },
  },
  data: () => ({
    textarea: "",
  }),
  props: {
    paragraphIndex: Number,
    materials: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleDelete(index) {
      this.editControl.removeMaterial(this.paragraphIndex, index);
    },
  },
};
</script>

<style lang="scss" scoped>
.mt15 {
  margin-top: 15px;
}
.mb15 {
  margin-bottom: 15px;
}
</style>